var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-2" },
      [
        _c(
          "jade-text",
          {
            attrs: {
              variant: "text-medium",
              weight: "medium",
              color: "neutral",
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t(_vm.computedDataByType.title)) + " ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _vm.showCurrency
          ? _c("emd-text", { attrs: { color: "#8B8B92", size: "tiny" } }, [
              _vm._v("R$"),
            ])
          : _vm._e(),
        _c("chart-line", {
          attrs: {
            data: _vm.computedDataByType.data,
            yAxisOptions: _vm.computedDataByType.yAxisOptions,
            tooltipConfig: _vm.computedDataByType.tooltipConfig,
            xlabels: _vm.computedDataByType.xLabels,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }